export default __webpack_public_path__ + "static/media/ic-telpon.6adf573b.svg";